import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { ImageCropperModal } from "../shared/ImageCropperModal.component";
import { CompanyService } from "../../services/company.service";
import { getMyProfile } from "../../actions/user";
import { SomethingWentWrongToast } from "../generalComponets";

export const UpdateCompanyLogoModal = ({ open, onClose, companyId, onSuccess }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSave = async (blob, fileName = "logo.jpg", fileType = "image/jpeg") => {
    const file = new File([blob], fileName, { type: fileType });
    const formData = new FormData();
    formData.append("logo", file);

    setLoading(true);
    try {
      const response = await CompanyService.uploadLogo({ id: companyId, payload: formData });
      const data = response.data;
      dispatch(getMyProfile());
      onSuccess?.();
      toast(data.message, { type: "success" });
    } catch (err) {
      SomethingWentWrongToast();
      console.error("UpdateCompanyLogoModal ~ handleSave error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ImageCropperModal
      open={open}
      onClose={onClose}
      onSave={handleSave}
      title="Upload Company Logo"
      cropTitle="Position your logo"
      aspectRatio={1}
      outputSize={512}
      cropShape="rect"
      maxFileSizeMB={2}
      saveLabel={loading ? "Uploading…" : "Save Logo"}
    />
  );
};
